import { render, staticRenderFns } from "./TokensDemandViewContainer.vue?vue&type=template&id=efa64f0e&"
import script from "./TokensDemandViewContainer.vue?vue&type=script&lang=js&"
export * from "./TokensDemandViewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports